var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from '../../baseService';
const excludedPaths = [
    'blocks.*.data.payload',
    'blocks.*.data.validation',
    'blocks.*.data.variables',
];
export class NotesStateService extends BaseService {
    constructor(props) {
        super(props);
    }
    availableLayouts(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.available_layouts', params, this.prepareOptions(options));
            return res;
        });
    }
    open(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.open', params, this.prepareOptions(options));
            // if (isLocal() && [22954, 23307].includes(params.encounterId)) {
            //   res = await getMockData<T['OpenResponse']>(StateMock)
            // }
            // if (isLocal() && res.prepared && !res.prepared.signature && params.encounterId === 23766) {
            //   res.prepared.signature = StateMock.signature
            //   res.prepared.addendum = StateMock.addendum
            //   res.prepared.locked = true
            // }
            // if (isLocal() && res.prepared && !res.prepared?.signature && params.encounterId === 23767) {
            // res.prepared.signature = StateMock.signature
            // res.prepared.addendum = StateMock.addendum
            // res.prepared.locked = true
            // }
            // if (isLocal() && res.prepared && [23816].includes(params.encounterId)) {
            // http://localhost:3201/provider/#/appointments/19374/23816
            // res.prepared.layout.sections[0].content.unshift(
            // { ref: 'template_poc', content: [] },
            // { ref: 'template_vitals', content: [] },
            // { ref: 'mode_of_contact', content: [] },
            // { ref: 'template_examination_woundcare', content: [] },
            // { ref: 'template_examination_no_examination', content: [] },
            // { ref: 'template_examination_hands_on', content: [] },
            // { ref: 'template_examination_hands_off', content: [] },
            // { ref: 'template_ros', content: [] },
            // { ref: 'template_hx', content: [] },
            // { ref: 'template_hx_toc', content: [] },
            // )
            // res.prepared.blocks.push(VitalsTemplateBlockMock)
            // res.prepared.blocks.push(PocTemplateBlockMock)
            // res.prepared.blocks.push(ModeOfContactTemplateBlockMock)
            // res.prepared.blocks.push(ExaminationWoundcare)
            // res.prepared.blocks.push(ExaminationNoExamination)
            // res.prepared.blocks.push(ExaminationHandsOn)
            // res.prepared.blocks.push(ExaminationHandsOff)
            // res.prepared.blocks.push(RosMock)
            // res.prepared.blocks.push(HxTemplateBlockMock)
            // res.prepared.blocks.push(HxTocTemplateBlockMock)
            // }
            return res;
        });
    }
    refresh(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.refresh', params, this.prepareOptions(options));
            return res;
        });
    }
    switchLayout(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.switch_layout', params, this.prepareOptions(options));
            return res;
        });
    }
    runMacro(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.run_macro', params, this.prepareOptions(options));
            return res;
        });
    }
    insertBlock(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.insert_block', params, this.prepareOptions(options));
            return res;
        });
    }
    saveBlock(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.save_block', params, this.prepareOptions(options));
            return res;
        });
    }
    saveTemplate(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.save_template', params, this.prepareOptions(options));
            return res;
        });
    }
    saveTemplateText(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.save_template_text', params, this.prepareOptions(options));
            return res;
        });
    }
    deleteBlock(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.delete_block', params, this.prepareOptions(options));
            return res;
        });
    }
    moveBlock(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.move_block', params, this.prepareOptions(options));
            return res;
        });
    }
    /*
     * Signing
     */
    sign(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.sign', params, this.prepareOptions(options));
            return res;
        });
    }
    openSigned(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.state.open_signed', params, this.prepareOptions(options));
            // if (isLocal() && !res.prepared.signature) {
            //   res.prepared.signature = StateMock.signature
            //   res.prepared.addendum = StateMock.addendum
            // }
            return res;
        });
    }
    prepareOptions(options) {
        return Object.assign(Object.assign({}, options), { prepareResultParams: { excludedPaths } });
    }
}
